import { render, staticRenderFns } from "./commonDormTimeLine.vue?vue&type=template&id=50fc6420&scoped=true"
import script from "./commonDormTimeLine.vue?vue&type=script&lang=js"
export * from "./commonDormTimeLine.vue?vue&type=script&lang=js"
import style0 from "./commonDormTimeLine.vue?vue&type=style&index=0&id=50fc6420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc6420",
  null
  
)

export default component.exports